
export const FETCH_DONATION = 'FETCH_DONATION';
export const FETCH_DONATION_FAILED = 'FETCH_DONATION_FAILED';
export const FETCH_DONATION_SUCCESS = 'FETCH_DONATION_SUCCESS';

export const CREATE_DONATION = 'CREATE_DONATION';
export const CREATE_DONATION_FAILED = 'CREATE_DONATION_FAILED';
export const CREATE_DONATION_SUCCESS = 'CREATE_DONATION_SUCCESS';

export const FETCHING_DONATION_SUMMARY = 'FETCHING_DONATION_SUMMARY';
export const FETCHING_DONATION_SUMMARY_SUCCESS = 'FETCHING_DONATION_SUMMARY_SUCCESS';
export const FETCHING_DONATION_SUMMARY_FAILED = 'FETCHING_DONATION_SUMMARY_FAILED';

export const FETCHING_COUNTRY_DONATION_SUMMARY = 'FETCHING_COUNTRY_DONATION_SUMMARY';
export const FETCHING_COUNTRY_DONATION_SUMMARY_FAILED = 'FETCHING_COUNTRY_DONATION_SUMMARY_FAILED';
export const FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS = 'FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS';
